import React, {ReactElement, ReactNode} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {LOGIN} from 'anonymous/routing/paths';
import LoggedInLayout from 'shared/components/layout/LoggedInLayout';
import {useIsLoggedIn} from 'shared/contexts/UserContext/useUserContext';

type Props = {
  children: ReactNode;
  path: string;
};

export default function PrivateRoutes({children, path}: Props): ReactElement {
  const isLoggedIn = useIsLoggedIn();
  return (
    <Route path={path}>
      {isLoggedIn && <LoggedInLayout>{children}</LoggedInLayout>}
      {!isLoggedIn && <Redirect to={LOGIN} />}
    </Route>
  );
}
